module.exports = __webpack_public_path__ + "/favicon.ico";


//////////////////
// WEBPACK FOOTER
// ./favicon.ico
// module id = 789
// module chunks = 8